import { Col, Row } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useRouter } from "next/router";
import { down } from "styled-breakpoints";
import styled from "styled-components";
import { Headline as Hl } from "sunday-component";
import { I18Text } from "src/types/i18Text";
import { color } from "../../styles/globals";

const CustomImage = styled("img")<{
  mobileHeight?: string;
  desktopHeight?: string;
}>`
  height: ${(props) => props.height || "auto"};
  ${down("lg")} {
    height: ${(props) => props.mobileHeight || "auto"};
  }
`;

const Headline = styled(Hl)<{
  textColor: string;
  lineHeight: string;
}>`
  color: ${(props) => props.textColor};
  position: relative;
  text-align: start;
  z-index: 1;
  line-height: ${(props) => props.lineHeight};
`;

const Container = styled.div`
  max-width: var(--content-max-width);
  margin: auto;
`;

const BannerRow = styled(Row)`
  margin: 0px 0px 16px 16px;
`;

const TitleContainer = styled.div`
  width: 100%;
`;

const TitleHeader = styled.h1`
  margin: 0px;
`;

export type ProductCategoryBannerProp = {
  title: I18Text;
  desktopImage: string;
  mobileImage: string;
  content: any;
};

const EntryFormBanner = ({
  title,
  desktopImage,
  mobileImage,
  content,
}: ProductCategoryBannerProp) => {
  const { md, xl } = useBreakpoint();
  const router = useRouter();
  const { locale } = router;

  const styles = {
    banner: {
      backgroundColor: content.categoryBanner.bgColor,
      maxHeight: "184px",
    },
  };

  return (
    <div style={styles.banner}>
      <Container>
        <BannerRow align="middle" wrap={false}>
          <Col flex="auto">
            <TitleHeader>
              <TitleContainer>
                {!xl ? (
                  <Headline
                    data-testid="title-entry-form-banner"
                    data-gtm-input-code="title-entry-form-banner"
                    level={7}
                    textColor={
                      content?.categoryBanner?.titleColor || color.charcoal10
                    }
                    lineHeight="24px"
                  >
                    {title?.[locale]}
                  </Headline>
                ) : (
                  <Headline
                    data-testid="title-entry-form-banner"
                    data-gtm-input-code="title-entry-form-banner"
                    level={2}
                    textColor={
                      content?.categoryBanner?.titleColor || color.charcoal10
                    }
                    lineHeight="42px"
                  >
                    {title?.[locale]}
                  </Headline>
                )}
              </TitleContainer>
            </TitleHeader>
          </Col>
          <Col flex={!xl ? "140px" : "790px"}>
            <Row justify="end">
              <CustomImage
                data-testid="img-entry-form-banner"
                data-gtm-input-code="img-entry-form-banner"
                src={!md ? mobileImage : desktopImage}
                alt="entry-form-banner"
                mobileHeight="136px"
                height="184px"
              />
            </Row>
          </Col>
        </BannerRow>
      </Container>
      {/* <div>
        <Hero
          data-testid="title-entry-form-banner"
          data-gtm-input-code="title-entry-form-banner"
          level={3}
          style={{
            position: "relative",
            textAlign: "start",
            ...styles.title,
          }}
        >
          {lang === "th" ? title.th : title.en}
        </Hero>
        <Row justify={!lg ? "end" : "start"}>
          <CustomImage
            data-testid="img-entry-form-banner"
            data-gtm-input-code="img-entry-form-banner"
            src={!md ? mobileImage : desktopImage}
            alt="entry-form-banner"
            mobileHeight="110px"
            height="184px"
          />
        </Row>
      </div> */}
    </div>
  );
};

export default EntryFormBanner;
